import * as React from "react";
// import AdminExportPurchasePage from "../../src/Admin/AdminTrades/AdminExportPurchasePage";
import { PageContainer } from "../../src/Basic/PageContainer";
import { TextContainer } from "../../src/Basic/TextContainer";
import dynamic from "next/dynamic";
import AdminExportPurchasePage from "../../src/Admin/AdminTrades/AdminExportPurchasePage";

export default function AdminExportTradeRoute() {
  return (
    <PageContainer>
      <TextContainer maxWidth={"xs"}>
        <AdminExportPurchasePage></AdminExportPurchasePage>
      </TextContainer>
    </PageContainer>
  );
}
